import React, { ReactNode, memo } from 'react';

import { twMerge } from 'tailwind-merge';
import Image from 'tracking-fe/src/Components/Common/Image';

export interface IOrderInfoBlock {
  title?: ReactNode;
  value?: ReactNode;
  imgSrc?: string;
  className?: string;
  icon?: ReactNode;
}
const OrderInfoBlock = memo(({ title, value, imgSrc, className, icon }: IOrderInfoBlock) => {
  return (
    <div className={twMerge('flex gap-4 items-center px-4 font-inter', className)}>
      {icon && icon}
      {imgSrc && (
        <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
          <Image
            src={imgSrc}
            minHeight="32px"
            minWidth="32px"
            alt="logo"
            height="32px"
            width="32px"
          />
        </div>
      )}
      <div className="flex flex-col">
        <div className="text-xs text-v2blueGray-500">{title}</div>
        <div className="text-sm text-text-v2blueGray-800">{value}</div>
      </div>
    </div>
  );
});

OrderInfoBlock.displayName = 'OrderInfoBlock';

export { OrderInfoBlock };
